import { useParams } from 'react-router-dom';
import { SEO } from 'src/common/components';
import { FeatureFlagName, MAIN_DOMAIN_URL } from 'src/common/constants';
import { PATH_OUTLINE_JSON_LD_BASE_SCHEMA } from 'src/common/components/seo/seo.constants';
import { useFeatureFlag } from 'src/common/hooks';
import { useFeatureIsOn } from 'src/common/growthbook';
import { PathOutlineBanner } from './components/path-outline-banner/path-outline-banner';
import { PathOutlineMainContent } from './components/path-outline-main-content/path-outline-main-content';
import { useGetSinglePathOutlineQuery } from './path-outline.slice';
import { StyledLoadingSpacer } from './path-outline.styles';
import { defaultSinglePathData } from './path-outline.constants';
export const PathOutline = () => {
  const {
    path: pathCode
  } = useParams();
  const {
    data: pathData,
    isLoading
  } = useGetSinglePathOutlineQuery(pathCode ?? '', {
    skip: !pathCode
  });
  const path = pathData?.data ?? defaultSinglePathData;
  const {
    enabled: showSocSimAdEnabled
  } = useFeatureFlag(FeatureFlagName.SOC_SIM_AD_BANNER_IN_PATHS);
  const isCertificationReleaseEnabled = useFeatureIsOn('certification-release');
  if (isLoading || !pathCode) {
    return <StyledLoadingSpacer data-testid="loading-spacer" />;
  }
  const {
    title,
    summary,
    taskNo,
    rooms,
    difficulty,
    banner,
    intro,
    description,
    modules,
    isRetired,
    alternativePath
  } = path;
  return <>
      <SEO title={title} titleSuffix="Training" description={summary} imageURL={banner} jsonLd={{
      ...PATH_OUTLINE_JSON_LD_BASE_SCHEMA,
      image: [banner],
      educationalLevel: difficulty,
      name: title,
      description: summary,
      provider: {
        '@type': 'Organization',
        name: 'TryHackMe',
        sameAs: `${MAIN_DOMAIN_URL}/path/outline/${pathCode}`
      }
    }} data-sentry-element="SEO" data-sentry-source-file="path-outline.tsx" />
      <PathOutlineBanner pathCode={pathCode} title={title} summary={summary} taskNo={taskNo} rooms={rooms} difficulty={difficulty} isRetired={isRetired} alternativePath={alternativePath} data-sentry-element="PathOutlineBanner" data-sentry-source-file="path-outline.tsx" />
      <PathOutlineMainContent title={title} banner={banner} intro={intro} description={description} modules={modules} showSocSimAd={showSocSimAdEnabled && ['soclevel1', 'soclevel2'].includes(pathCode)} showSal1Ad={isCertificationReleaseEnabled && ['soclevel1'].includes(pathCode)} isRetired={isRetired} data-sentry-element="PathOutlineMainContent" data-sentry-source-file="path-outline.tsx" />
    </>;
};